import {
  Box,
  makeStyles,
  Paper,
  SvgIcon,
  Tooltip,
  withStyles,
} from '@material-ui/core';
import { getUserApplicableSettings } from '@src/selectors/chatAutoAssignment';
import { totalChatsRequestSelector } from '@src/selectors/chats';
import { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { LockIcon } from './SvgIcons';

const ZERO = 0;
const TEN = 10;
const NINETY_NINE = 99;

const BadgeCountBlockedWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const settings = useSelector(getUserApplicableSettings);
  const counter = useSelector(totalChatsRequestSelector);
  const { traySizeLimit } = settings;
  const warningMessage = formatMessage(
    { id: 'ChatAutoAssignment.chatRequests.warning.message' },
    { chatsLimit: traySizeLimit }
  );
  return (
    <BadgeCountBlocked warningMessage={warningMessage} counter={counter}>
      {children}
    </BadgeCountBlocked>
  );
};

export type BadgeCountBlockedProps = {
  children?: React.ReactNode;
  warningMessage: string;
  counter: number;
};

export const BadgeCountBlocked: React.FC<BadgeCountBlockedProps> = ({
  warningMessage,
  counter,
  children,
}) => {
  const { commonStyle } = useStyles();
  const withNoCounterStyle: CSSProperties = {
    width: '20px',
    height: '20px',
  };

  const withCounterStyle: CSSProperties = {
    borderRadius: '100px',
    width: counter < TEN ? '30px' : '40px',
    height: '20px',
  };

  const counterVal = counter > NINETY_NINE ? '+99' : `${counter}`;

  return (
    <>
      <Paper
        className={commonStyle}
        style={counter ? withCounterStyle : withNoCounterStyle}
        elevation={0}
      >
        <TooltipStyled title={warningMessage} placement="right" arrow>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            fontSize="10px"
            fontWeight={700}
          >
            {counter > ZERO && <Box px="2px">{counterVal}</Box>}
            <SvgIcon color="inherit" style={{ fontSize: '14px' }}>
              {LockIcon}
            </SvgIcon>
          </Box>
        </TooltipStyled>
      </Paper>
      {children}
    </>
  );
};

const TooltipStyled = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.b2chatorange[100],
    color: theme.palette.text.primary,
    fontSize: '10px',
  },
  arrow: {
    color: theme.b2chatorange[100],
  },
}))(Tooltip);

const useStyles = makeStyles(theme => ({
  commonStyle: {
    borderRadius: '100px',
    width: '20px',
    height: '20px',
    fontSize: '15px',
    display: 'inline-block',
    position: 'absolute',
    left: '50px',
    top: 0,
    backgroundColor: theme.b2chatorange[600],
    color: '#fff',
    fontWeight: 500,
    lineHeight: '140%',
  },
}));

export default BadgeCountBlockedWrapper;
